import React, {useState, useEffect} from 'react';

import restApi from '../../../api/Source';
import { withRouter } from 'react-router-dom';
import LoadingSpinner from '../../../components/user/LoadingSpinner/LoadingSpinner';
import Header from "../../../components/user/Header/Header";
import MenuComponent from "../../../components/user/MenuComponent/MenuComponent";
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import Badge from 'react-bootstrap/Badge';


import './Menu.css';

function Menu(props) {

    // TODO Claudiu if path has a category (as query param best), get the specific products and render them
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const [products, setProducts] = useState([]);
    const [commercialAdaos, setCommercialAdaos] = useState(0);
    const [isLoading, setLoading] = useState(true);
    const [menuHierarchy, setMenuHierarchy] = useState();
    // for menu
    const depthLevel = 0;

    const navigateTo = (page) => {
        props.history.push(page);
    }

    if (localStorage.getItem("isAuthenticated") === false || localStorage.getItem("userRole") !== "USER") {
        navigateTo('/');
    }

    useEffect(() => {
        window.scroll(0, 0);
        if (localStorage.getItem("commercialAdaos") !== null && localStorage.getItem("commercialAdaos") !== undefined) {
            setCommercialAdaos(localStorage.getItem("commercialAdaos"));
        }
        setLoading(true);
        restApi.get("/services/menu/hierarchy").then(menuHierarchyResponse => {
            setMenuHierarchy(menuHierarchyResponse.data);
            console.log(menuHierarchy);
        }).catch(error => {
            setLoading(false);
            if (error.response.status === 401) {
                navigateTo('/');
            }
        }).then(() => {
            if (searchParams.get("menuName") !== null && searchParams.get("menuName") !== undefined && searchParams.get("menuName") !== '') {
                restApi.get("/services/menu?menuName=" + searchParams.get("menuName")).then(productsResponse => {
                    setProducts(productsResponse.data);
                    setLoading(false);
                }).catch(error => {
                    setLoading(false);
                    if (error.response.status === 401) {
                        navigateTo('/');
                    }
                })
            } else {
                setLoading(false);
            }
        });
    }, []);

    const addToCart = (product) => {
        props.addToCart(product);
    }
    
    return (
        <div className="page-container menu-page">
            <div id="content-wrap">
                <Header {...props} />
            </div>
            {isLoading === true && 
                <LoadingSpinner />
            }
            {isLoading === false && 
                <div className="container-fluid mt-4">
                    <div className="row">
                        <div className="col-12 col-lg-3 mb-4 mb-lg-0">
                            <div className="menus">
                                <ul>
                                    {menuHierarchy && menuHierarchy.map((menu, index) => (
                                        <MenuComponent items={menu} key={index} depthLevel={depthLevel} />
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col-12 col-lg-9">
                            {products !== null && products !== undefined && products.length > 0 ? (
                                <div className="row">
                                    {products.map((product, index) => (
                                        <div key={`${product.supplierId}-${product.articleNumber}-${index}`} className="col-12 mb-3">
                                            <div className="card shadow-sm product-card h-100">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-12 col-md-2 mb-3 mb-md-0 text-center">
                                                            {product.media && product.media.type === "1" ? (
                                                                <img 
                                                                    src={`/media/img/${product.media.source}`} 
                                                                    className="img-fluid" 
                                                                    alt={product.productName}
                                                                    style={{ maxHeight: '150px', objectFit: 'contain' }}
                                                                />
                                                            ) : (
                                                                <div className="bg-light d-flex align-items-center justify-content-center" style={{ height: '150px' }}>
                                                                    <span className="text-muted small">Fără imagine</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="col-12 col-md-6 mb-3 mb-md-0">
                                                            <a 
                                                                href={`/product/${encodeURIComponent(product.supplierId)}/${encodeURIComponent(product.articleNumber)}`}
                                                                className="text-decoration-none text-dark"
                                                            >
                                                                <h6 className="font-weight-bold mb-1">{product.productName}</h6>
                                                                <p className="text-muted small mb-1">{product.supplierBrand}</p>
                                                                <p className="text-secondary small mb-0">{product.articleNumber}</p>
                                                            </a>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <p className="mb-2">
                                                                    <small className="text-muted">Pret cu TVA: </small>
                                                                    <strong className="text-success" style={{ fontSize: '1.1rem' }}>
                                                                        {commercialAdaos > 0 
                                                                            ? (product.price + (product.price * commercialAdaos / 100)).toFixed(2)
                                                                            : product.price.toFixed(2)
                                                                        } RON
                                                                    </strong>
                                                                </p>
                                                            </div>
                                                            <div className="mb-3">
                                                                {product.stockBG1 !== null && product.stockBG1 > 0 && (
                                                                    <Badge variant="success" className="mr-1 mb-1" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>BG1: {product.stockBG1}</Badge>
                                                                )}
                                                                {product.stockBG2 !== null && product.stockBG2 > 0 && (
                                                                    <Badge variant="info" className="mr-1 mb-1" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>BG2: {product.stockBG2}</Badge>
                                                                )}
                                                                {product.stockProviders !== null && product.stockProviders > 0 && (
                                                                    <Badge variant="warning" className="mb-1" style={{ fontSize: '0.9rem', padding: '0.4rem 0.6rem' }}>RO: {product.stockProviders}</Badge>
                                                                )}
                                                            </div>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-primary btn-sm btn-block" 
                                                                onClick={() => addToCart(product)}
                                                            >
                                                                <FontAwesomeIcon icon={faShoppingCart} className="mr-1" />
                                                                Adauga in cos
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : products !== null && products !== undefined && products.length === 0 && searchParams.get("menuName") ? (
                                <div className="text-center py-5">
                                    <h5 className="mb-3">Nu există produse disponibile</h5>
                                    <p className="text-muted">Momentan nu sunt produse disponibile pentru această categorie.</p>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default withRouter(Menu)